/* eslint no-restricted-syntax: 0 */
import { parse, format } from 'url';

import { Cookies } from '@confluence/cookies';

export const BRANCH_VERSION = 'useFrontendBranch';
export const BUILD_VERSION = 'useFrontendBuildVersion';
const BIFROST_OVERRIDE = 'bifrost-override';

export const exitBranchFn = () => {
	const urlComponents = parse(window.location.href, true);

	Cookies.remove(BIFROST_OVERRIDE);
	Cookies.remove(BRANCH_VERSION);
	Cookies.remove(BUILD_VERSION);

	window.location.assign(
		format({
			path: urlComponents.path,
			query: {
				...urlComponents.query,
				[BRANCH_VERSION]: 'off',
				[BUILD_VERSION]: 'off',
			},
			hash: urlComponents.hash,
		}),
	);
};

export const isBranchDeployFn = () => {
	if (window.__SSR_RENDERED__) {
		try {
			const bifrostOverrideVersion = Cookies.get(BIFROST_OVERRIDE);
			if (bifrostOverrideVersion) {
				return !bifrostOverrideVersion.includes('CLASSIC-off-off');
			}
		} catch (err) {
			// Fall back to the frontend branch cookie if the Bifrost cookie cannot be read.
		}
	}

	let cookieBasedBranchVersion;
	try {
		cookieBasedBranchVersion = Cookies.get(BRANCH_VERSION);
	} catch (err) {
		// Likely a Firefox edge case: "Error: can't access dead object".
		// document.cookie can be cleaned up despite living references in js-cookie.
		cookieBasedBranchVersion = 'off';
	}

	return !!(cookieBasedBranchVersion && cookieBasedBranchVersion !== 'off');
};
